/**
 * Portuguese About Translations
 * 关于页翻译模块 - 葡萄牙语
 * 
 * 包含公司介绍、发展历程、使命价值观、认证专利等翻译
 */

import type { AboutTranslations } from '../../types';

export const ptAbout: AboutTranslations = {
  title: 'Sobre Nós',
  subtitle: 'Inovando conforto para um futuro sustentável.',
  header: {
    title: 'Sobre a JH Heatsup',
    subtitle: 'Inovando conforto para um futuro sustentável.',
  },
  history: {
    title: 'Nossa História',
    desc: 'Fundada em 2006, Fujian Jinghui Environmental Technology Co., Ltd. (JH Heatsup) começou com uma visão simples: criar soluções de aquecimento e refrigeração que não sejam apenas poderosas, mas também ambientalmente responsáveis. Localizados no movimentado Parque de Alta Tecnologia de Fuzhou, crescemos de uma pequena equipe de P&D para um fabricante global.',
    timelineTitle: 'Marcos do aquecimento infravermelho',
    timelineDesc: 'Seis marcos que acompanham nossa evolução das primeiras séries de infravermelho distante às soluções conectadas e de aquecimento rápido para banheiros.',
    milestones: [
      { year: '2013', title: 'Início da produção infravermelha', desc: 'As séries 13A e 13B de aquecedores radiantes de infravermelho distante entraram em produção.' },
      { year: '2015', title: 'Expansão da linha de produtos', desc: 'Lançamos as séries 14A/14B e 15A/15B de aquecedores de infravermelho distante.' },
      { year: '2017', title: 'Aquecimento com Bluetooth', desc: 'A série JH13C chegou ao mercado com alto-falante Bluetooth integrado.' },
      { year: '2018', title: 'Soluções para mais ambientes', desc: 'Lançamos aquecedores de rodapé e iniciamos a produção de aquecedores infravermelhos para banheiros.' },
      { year: '2019', title: 'Aquecimento inteligente com Wi-Fi', desc: 'A série conectada 13W foi lançada com funcionalidade Wi-Fi integrada.' },
      { year: '2021', title: 'Calor no banheiro em cinco segundos', desc: 'Desenvolvemos um aquecedor de banheiro com painel de vidro capaz de aquecer em apenas cinco segundos.' },
    ],
  },
  mission: {
    title: 'Nossa Missão',
  },
  quality: {
    title: 'Garantia de Qualidade',
    desc: 'Processos certificados ISO9001. Cada aquecedor é testado antes de sair de nossa fábrica.',
  },
  values: {
    title: 'Nossos Valores Fundamentais',
    sustainability: {
      title: 'Sustentabilidade e Inovação',
      desc: 'Inovando em tecnologias de economia de energia para reduzir a pegada de carbono e maximizar a eficiência de aquecimento.',
    },
    quality: {
      title: 'Qualidade Certificada',
      desc: 'Construído em instalações certificadas ISO9001 e rigorosamente testado para garantir desempenho premium.',
    },
    customerFirst: {
      title: 'Confiança e Parceria Global',
      desc: 'Confiado por mais de 800 parceiros globais em mais de 100 países, construindo relacionamentos duradouros através de um serviço centrado no cliente.',
    },
  },
  features: {
    title: 'Características do Produto',
    fast: {
      title: 'Aquecimento Rápido',
      desc: 'Aquecimento rápido com tecnologia infravermelha eficiente.',
    },
    energy: {
      title: 'Economia de Energia',
      desc: 'Controle inteligente ajuda a reduzir os custos de aquecimento.',
    },
    healthy: {
      title: 'Conforto Saudável',
      desc: 'Calor radiante sem ressecar o ar.',
    },
    safe: {
      title: 'Seguro e Confiável',
      desc: 'Múltiplas proteções de segurança para sua tranquilidade.',
    },
  },
  companyProfile: {
    title: 'Perfil da Empresa',
    desc: 'A Fujian Jinghui Environmental Technology Co., Ltd. foi fundada em 2006 e tem sede em Fuzhou, China. Somos uma empresa de alta tecnologia especializada na pesquisa e produção de aquecedores de radiação infravermelha de longo alcance. Seguindo a filosofia empresarial "Buscar a excelência, criar brilho juntos", estamos comprometidos em oferecer soluções de aquecimento eficientes, econômicas em energia, saudáveis e confortáveis para usuários no mundo todo.',
  },
  services: {
    title: 'Serviços Profissionais',
    desc: 'Contamos com engenheiros técnicos e uma equipe comercial experiente para oferecer serviços de alta qualidade em aplicações industriais e comerciais de aquecimento. Fornecemos produtos de qualidade e boas soluções para temperatura confortável, controle de umidade e ar fresco em oficinas, shoppings, academias, cafeterias, estufas, áreas externas e outros locais.',
  },
  technology: {
    title: 'Tecnologia Líder',
    desc: 'Aplicamos tinta nano-cerâmica a aquecedores de radiação infravermelha de longo alcance, reduzindo problemas como descoloração e descascamento de tinta em aquecedores tradicionais, tornando a radiação mais eficiente e rápida. Nossa tecnologia avançada de infravermelho distante proporciona aquecimento rápido e distribuição uniforme de calor para um ambiente de vida quente e confortável.',
    nanoCeramic: { title: 'Tecnologia Nano-Cerâmica', desc: 'Maior eficiência de radiação para aquecimento mais rápido' },
    farInfrared: { title: 'Radiação Infravermelha Distante', desc: 'Distribuição uniforme de calor para conforto' },
  },
  certifications: {
    title: 'Certificações e Patentes',
    desc: 'Obtivemos mais de 32 patentes de design, modelos de utilidade e invenções. Nossos produtos atendem a padrões internacionais de certificação de segurança como CCC, ISO9001:2015, CE, CB, SAA, EMC e SASO, garantindo qualidade confiável.',
  },
  clients: {
    title: 'Clientes Globais',
    desc: 'Nossos produtos de aquecimento foram exportados para mais de 100 países e regiões em todo o mundo, com a confiança de usuários globalmente.',
    export: 'Exportação para mais de 100 países e regiões',
    agents: 'Mais de 800 agentes internacionais',
    trusted: 'Confiado por usuários em todo o mundo',
    showcaseTitle: 'A confiança de parceiros em todo o mundo',
    showcaseDesc: 'Em feiras internacionais, encontramos pessoalmente distribuidores, compradores de projetos e profissionais do setor de vários países. Essas conversas nos ajudam a compreender as necessidades locais de aquecimento, apresentar nossas soluções infravermelhas mais recentes e construir parcerias duradouras com produtos confiáveis, qualidade consistente e suporte ágil.',
  },
  manufacturing: {
    title: 'Capacidade de Fabricação',
    desc: 'Temos uma oficina de produção de 8.000 m², com mais de 150 engenheiros técnicos e colaboradores qualificados, e capacidade mensal superior a 10.000 aquecedores. Temos condições de concluir cada pedido no prazo, com qualidade e na quantidade necessária.',
    workshopArea: 'Área da oficina',
    engineersWorkers: 'Engenheiros e operários',
    monthlyCapacity: 'Capacidade mensal',
    patents: 'Patentes',
  },
  ceo: {
    title: 'Nossa Fundadora',
    name: 'Sra. Huang Xuefang',
    role: 'Fundadora',
    desc: 'A Sra. Huang Xuefang é uma das primeiras pesquisadoras e designers de aquecedores de infravermelho distante na China. Em 2003, trabalhou com um grupo de parceiros apaixonados por tecnologia de aquecimento no desenvolvimento e design de produtos evaporativos. Em 2006, fundou a Fujian Jinghui Environmental Technology Co., Ltd. Em 2011, liderou a equipe de P&D no design de aquecedores de radiação infravermelha distante do tipo painel, integrando de forma inteligente controles inteligentes, alto-falantes Bluetooth e Wi‑Fi aos aquecedores, tornando-os não apenas dispositivos de aquecimento, mas também um estilo de vida. Cada detalhe do design reflete sua fusão entre a estética ocidental e o charme oriental, dando aos produtos uma vitalidade marcante.',
    quote: '"Estamos comprometidos em criar um mundo mais verde e acolhedor através da tecnologia."',
  },
  applications: {
    title: 'Cenários de Aplicação',
    desc: 'Nossos aquecedores de infravermelho distante são amplamente utilizados em vários cenários, fornecendo soluções de aquecimento completas para você',
    restaurant: {
      title: 'Restaurante',
      desc: '',
      icon: 'Utensils',
    },
    livingRoom: {
      title: 'Sala de Estar',
      desc: '',
      icon: 'Sofa',
    },
    office: {
      title: 'Escritório',
      desc: '',
      icon: 'Building',
    },
    patio: {
      title: 'Terraço',
      desc: '',
      icon: 'Sun',
    },
    sauna: {
      title: 'Sala de Sauna',
      desc: '',
      icon: 'Flame',
    },
    garage: {
      title: 'Garagem',
      desc: '',
      icon: 'Warehouse',
    },
    balcony: {
      title: 'Academia',
      desc: '',
      icon: 'Dumbbell',
    },
    entertainment: {
      title: 'Sala de Entretenimento',
      desc: '',
      icon: 'Gamepad2',
    },
  },
};
